import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import CalonMhsService from "../../services/CalonMhsService";
import {message,notification} from "antd";
import {AUTH_ID_PENDAFTAR, AUTH_NOMOR_PENDAFTARAN, AUTH_TOKEN} from "../../constants/AuthConstant";
import calonMhsService from "../../services/CalonMhsService";
import SyaratDaftarService from "../../services/SyaratDaftarService";

export const initialState = {
    loading: false,
    dataKonfirmasi: [],
    showMessage:false,
    message:'',
    statusPostDetail:'',
    messagePostDetai:'',
    loadingPostDetail:false,
    dataPendaftar:[],
    loadingSyaratPendaftar:false,
    dataSyaratPendaftar:[],
    dataDetailPendaftar:[],
    dataDetailPendaftar2:[],
    dataHasilPendaftar:[],
    loadingDetailPendaftar: false,
    statusSimpanPermanen:'',
    loadingSimpanPermanen:false,
    loadingDelete:false,
    loadingHasil:false,
    statusDelete:'',
    statusPostPendidikan:'',
    loadingPostPendidikan:false,
    messagePostPendidikan:'',
    statusPostJasAlm:'',
    loadingPostJasAlm:false,
    messagePostJasAlm:'',
    statusPostPekerjaan:'',
    loadingPostPekerjaan:false,
    messagePostPekerjaan:'',
    statusPostAkunUM:'',
    loadingPostAkunUM:false,
    messagePostAkunUM:'',
    statusPostDefer: '',
    loadingPostDefer: false,
}


export const getDataPendaftar = createAsyncThunk('transaksi/pendaftar',async (data, { rejectWithValue }) => {
    const {id_pendaftar}=data;
    try {
        const response = await calonMhsService.getData(localStorage.getItem(AUTH_TOKEN),id_pendaftar)
        //console.log(JSON.stringify(response))
        if(response.success!=true){
            message.error(response.message || 'Error',3)
        }
        return response
    } catch (err) {
        message.error(err.response?.data?.message || 'Sesi anda telah habis, silahkan login ulang!',3)
    }
})

export const getDataDetailPendaftar = createAsyncThunk('transaksi/detailpendaftar',async (data, { rejectWithValue }) => {
    let {konfirmasi}=data
    try {
        const response = await calonMhsService.getDataDetail(localStorage.getItem(AUTH_TOKEN),konfirmasi)
        //console.log(JSON.stringify(response))
        /*if(response.success!=true){
            message.error(response.message || 'Error',3)
        }*/
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const getDataSyaratPendaftar = createAsyncThunk('transaksi/pendaftar/syarat',async (data, { rejectWithValue }) => {
    const response=[];
    try {
            const response = await SyaratDaftarService.getDataByID(localStorage.getItem(AUTH_TOKEN),localStorage.getItem(AUTH_NOMOR_PENDAFTARAN))
            if(response.success!=true){
                message.error(response.message || 'Error',3)
            }else{
                return response
            }
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const postKonfirmasi = createAsyncThunk('transaksi/pendaftar/store',async (data, { rejectWithValue }) => {
    const {token,id_periode_daftar,id_kelas_sekolah}=data;
    try {
        const response = await calonMhsService.konfirmasi(token,{id_periode_daftar, id_user_daftar:localStorage.getItem(AUTH_NOMOR_PENDAFTARAN),id_kelas_sekolah})
        //console.log(JSON.stringify(response))
        if(response.success!=true){
            notification.error({
                message: 'Perhatian',
                className:"text-danger",
                description:response.message||'error',
                duration:3
            });
        }else {
            message.success('Mohon tunggu, akan dialihkan ke halaman pembayaran',3,function () {
                window.location.href = response.data.url_payment;
            });
        }
    } catch (err) {
        message.error(err.response?.data?.message || 'Sesi anda telah habis, silahkan login ulang!',3)
    }
})

export const postDetail = createAsyncThunk('transaksi/pendaftar/detail/store',async (data, { rejectWithValue }) => {
    const {id_pendaftar}=data
    try {
        const response = await calonMhsService.postDetail(localStorage.getItem(AUTH_TOKEN),data.values)
        //console.log(JSON.stringify(response))
        if(response.success!=true){
            message.error(response.message || 'Error',3)
        }else{
            message.success(response.message,3);
        }
        return response

    } catch (err) {
        message.error(err.response?.data?.message || 'Sesi anda telah habis, silahkan login ulang!',3)
    }
})

export const postSimpanPermanen = createAsyncThunk('transaksi/pendaftar/simpanpermanen',async (data, { rejectWithValue }) => {
    const {id_pendaftar,is_defer}=data;
    try {
        const response = await CalonMhsService.postSimpanPermanen(localStorage.getItem(AUTH_TOKEN),{id_pendaftar,is_defer})
        //console.log(JSON.stringify(response))
        if(response.success!=true){
            message.error(response.message || 'Error',3)
        }
        return response
    } catch (err) {
        message.error(err.response?.data?.message || 'Sesi anda telah habis, silahkan login ulang!',3)
    }
})

export const postDelete = createAsyncThunk('transaksi/pendaftar/delete',async (data, { rejectWithValue }) => {
    const {id_pendaftar}=data;
    try {
        const response = await CalonMhsService.delete(localStorage.getItem(AUTH_TOKEN),{id_pendaftar})
        //console.log(JSON.stringify(response))
        if(response.success!=true){
            message.error(response.message || 'Error',3)
        }
        return response
    } catch (err) {
        message.error(err.response?.data?.message || 'Sesi anda telah habis, silahkan login ulang!',3)
    }
})

export const getPendaftarHasil = createAsyncThunk('transaksi/pendaftar/hasil',async (data, { rejectWithValue }) => {
    const {id_pendaftar}=data;
    try {
        const response = await CalonMhsService.hasil(localStorage.getItem(AUTH_TOKEN),{id_pendaftar})
        //console.log(JSON.stringify(response))
        if(response.success!=true){
            message.error(response.message || 'Error',3)
        }
        return response
    } catch (err) {
        message.error(err.response?.data?.message || 'Sesi anda telah habis, silahkan login ulang!',3)
    }
})

export const postPendidikan = createAsyncThunk('transaksi/pendidikan/store',async (data, { rejectWithValue }) => {
    try {
        const response = await calonMhsService.postPendidikan(localStorage.getItem(AUTH_TOKEN),data.values)
        //console.log(JSON.stringify(response))
        if(response.success!=true){
            message.error(response.message || 'Error',3)
        }else{
            message.success(response.message,3);
        }
        return response

    } catch (err) {
        message.error(err.response?.data?.message || 'Sesi anda telah habis, silahkan login ulang!',3)
    }
})

export const postJasAlm = createAsyncThunk('transaksi/jasalm/store',async (data, { rejectWithValue }) => {
    const {ukuran_jas_almamater}= data
    try {
        const response = await calonMhsService.postJasAlm(localStorage.getItem(AUTH_TOKEN),{ukuran_jas_almamater})
        //console.log(JSON.stringify(response))
        if(response.success!=true){
            message.error(response.message || 'Error',3)
        }else{
            message.success(response.message,3);
        }
        return response

    } catch (err) {
        message.error(err.response?.data?.message || 'Sesi anda telah habis, silahkan login ulang!',3)
    }
})

export const postPekerjaan = createAsyncThunk('transaksi/pekerjaan/store',async (data, { rejectWithValue }) => {
    try {
        const response = await calonMhsService.postPekerjaan(localStorage.getItem(AUTH_TOKEN),data.values)
        //console.log(JSON.stringify(response))
        if(response.success!=true){
            message.error(response.message || 'Error',3)
        }else{
            message.success(response.message,3);
        }
        return response

    } catch (err) {
        message.error(err.response?.data?.message || 'Sesi anda telah habis, silahkan login ulang!',3)
    }
})

export const postAkunUM = createAsyncThunk('transaksi/akumum/store',async (data, { rejectWithValue }) => {
    try {
        const response = await calonMhsService.postAkunUM(localStorage.getItem(AUTH_TOKEN),data.values)
        //console.log(JSON.stringify(response))
        return response

    } catch (err) {
        message.error(err.response?.data?.message || 'Sesi anda telah habis, silahkan login ulang!',3)
    }
})

export const postDefer = createAsyncThunk('transaksi/defer/store', async (data, { rejectWithValue }) => {
    try {
        const response = await calonMhsService.postDefer(localStorage.getItem(AUTH_TOKEN), data)
        if (response.success !== true) {
            message.error(response.message || 'Error saving defer status', 3)
        }
        return response
    } catch (err) {
        message.error(err.response?.data?.message || 'Sesi anda telah habis, silahkan login ulang!', 3)
        return rejectWithValue(err.response.data)
    }
})
export const calonMhsSlice = createSlice({
    name: 'calonmhs',
    initialState,
    reducers: {
            postKonfirmasiSuccess: (state, action) => {
                state.loading = false
                state.dataKonfirmasi = action.payload
            },
            showLoadingPostKonfirmasi: (state) => {
                state.loading = true
            },
            postDetailSuccess: (state, action) => {
                state.loadingPostDetail = false
                state.statusPostDetail = action.payload.success
                state.messagePostDetail=action.payload.message
            },
            showLoadingPostDetail: (state) => {
                state.loadingPostDetail = true
            },
            showDataPendaftar:(state,action) => {
                state.dataPendaftar = action.payload
            },
            showSyaratPendaftar:(state,action) => {
                state.dataSyaratPendaftar = action.payload
                state.loadingSyaratPendaftar=false
            },
            showDataDetailPendaftar:(state,action) => {
                state.dataDetailPendaftar = action.payload
                state.dataDetailPendaftar2 = action.payload.data
            },
            showLoadingPostSimpanPermanen: (state) => {
                state.loadingSimpanPermanen = true
            },
            showLoadingPostPendidikan: (state) => {
                state.loadingPostPendidikan = true
            },
            showLoadingPostJasAlm: (state) => {
                state.loadingPostJasAlm = true
            },
            showLoadingPostPekerjaan: (state) => {
                state.loadingPostPekerjaan = true
            },
            showLoadingPostAkunUM: (state) => {
            state.loadingPostAkunUM = true
        },
            showLoadingPostDefer: (state) => {
                state.loadingPostDefer = true
            }
        },
    extraReducers: (builder) => {
        builder
            .addCase(postKonfirmasi.fulfilled, (state, action) => {
                state.loading = false
                state.dataKonfirmasi = action.payload
            })
            .addCase(postKonfirmasi.pending, (state) => {
                state.loading = true
            })
            .addCase(postKonfirmasi.rejected, (state, action) => {
                state.message = action.payload
                state.showMessage = true
                state.loading = false
                state.dataKonfirmasi = action.payload
            })
            .addCase(postDetail.fulfilled, (state, action) => {
                state.loadingPostDetail = false
                state.statusPostDetail = action.payload.success
            })
            .addCase(postDetail.pending, (state) => {
                state.loadingPostDetail = true
            })
            .addCase(postDetail.rejected, (state, action) => {
                state.messagePostDetail = action.payload.message
                state.showMessage = true
                state.loadingPostDetail = false
                state.statusPostDetail = action.payload.success
            })
            .addCase(getDataPendaftar.fulfilled, (state, action) => {
                state.dataPendaftar = action.payload
                state.loading = false
            })
            .addCase(getDataPendaftar.pending, (state) => {
                state.loading = true
            })
            .addCase(getDataPendaftar.rejected, (state, action) => {
                state.dataPendaftar = action.payload
                state.loading = false
            })
            .addCase(getDataSyaratPendaftar.fulfilled, (state, action) => {
                //console.log(JSON.stringify(action.payload));
                state.dataSyaratPendaftar = action.payload
                state.loadingSyaratPendaftar=false
            })
            .addCase(getDataSyaratPendaftar.pending, (state) => {
                state.loadingSyaratPendaftar=true
            })
            .addCase(getDataSyaratPendaftar.rejected, (state, action) => {
                state.dataSyaratPendaftar = action.payload
                state.loadingSyaratPendaftar=false
            })
            .addCase(getDataDetailPendaftar.fulfilled, (state, action) => {
                state.dataDetailPendaftar = action.payload
                state.dataDetailPendaftar2 = action.payload.data
                state.loadingDetailPendaftar=false;
            })
            .addCase(getDataDetailPendaftar.pending, (state) => {
                state.loadingDetailPendaftar = true
            })
            .addCase(getDataDetailPendaftar.rejected, (state, action) => {
                state.dataDetailPendaftar = action.payload
                state.dataDetailPendaftar2 = action.payload.data
                state.loadingDetailPendaftar = false
            })
            .addCase(postSimpanPermanen.fulfilled, (state, action) => {
                state.loadingSimpanPermanen = false
                state.statusSimpanPermanen = action.payload.success
            })
            .addCase(postSimpanPermanen.pending, (state) => {
                state.loadingSimpanPermanen = true
            })
            .addCase(postSimpanPermanen.rejected, (state, action) => {
                state.loadingSimpanPermanen = false
                state.statusSimpanPermanen = action.payload.success
            })
            .addCase(postDelete.fulfilled, (state, action) => {
                state.loadingDelete = false
                state.statusDelete = action.payload.success
            })
            .addCase(postDelete.pending, (state) => {
                state.loadingDelete = true
            })
            .addCase(postDelete.rejected, (state, action) => {
                state.loadingDelete = false
                state.statusDelete = action.payload.success
            })
            .addCase(getPendaftarHasil.fulfilled, (state, action) => {
                state.loadingHasil = false
                state.dataHasilPendaftar = action.payload
            })
            .addCase(getPendaftarHasil.pending, (state) => {
                state.loadingHasil = true
            })
            .addCase(getPendaftarHasil.rejected, (state, action) => {
                state.loadingHasil = false
                state.dataHasilPendaftar = action.payload
            })
            .addCase(postPendidikan.fulfilled, (state, action) => {
                state.loadingPostPendidikan = false
                state.statusPostPendidikan = action.payload.success
            })
            .addCase(postPendidikan.pending, (state) => {
                state.loadingPostPendidikan = true
            })
            .addCase(postPendidikan.rejected, (state, action) => {
                state.messagePostPendidikan = action.payload.message
                state.showMessage = true
                state.loadingPostPendidikan = false
                state.statusPostPendidikan = action.payload.success
            })
            .addCase(postJasAlm.fulfilled, (state, action) => {
                state.loadingPostJasAlm = false
                state.statusPostJasAlm = action.payload.success
            })
            .addCase(postJasAlm.pending, (state) => {
                state.loadingPostJasAlm = true
            })
            .addCase(postJasAlm.rejected, (state, action) => {
                state.messagePostJasAlm = action.payload.message
                state.showMessage = true
                state.loadingPostJasAlm = false
                state.statusPostJasAlm = action.payload.success
            })
            .addCase(postPekerjaan.fulfilled, (state, action) => {
                state.loadingPostPekerjaan = false
                state.statusPostPekerjaan = action.payload.success
            })
            .addCase(postPekerjaan.pending, (state) => {
                state.loadingPostPekerjaan = true
            })
            .addCase(postPekerjaan.rejected, (state, action) => {
                state.messagePostPekerjaan = action.payload.message
                state.showMessage = true
                state.loadingPostPekerjaan = false
                state.statusPostPekerjaan = action.payload.success
            })
            .addCase(postAkunUM.fulfilled, (state, action) => {
                state.loadingPostAkunUM = false
                state.statusPostAkunUM = action.payload.success
            })
            .addCase(postAkunUM.pending, (state) => {
                state.loadingPostAkunUM = true
            })
            .addCase(postAkunUM.rejected, (state, action) => {
                state.messagePostAkunUM = action.payload.message
                state.showMessage = true
                state.loadingPostAkunUM = false
                state.statusPostAkunUM = action.payload.success
            })
            .addCase(postDefer.fulfilled, (state, action) => {
                state.loadingPostDefer = false
                state.statusPostDefer = action.payload.success
            })
            .addCase(postDefer.pending, (state) => {
                state.loadingPostDefer = true
            })
            .addCase(postDefer.rejected, (state, action) => {
                state.loadingPostDefer = false
                state.statusPostDefer = action.payload?.success
            })
    },
})

export const {
    postKonfirmasiSuccess,
    showLoadingPostKonfirmasi,
    postDetailSuccess,
    showLoadingPostDetail,
    showDataPendaftar,
    showSyaratPendaftar,
    showDataDetailPendaftar,
    showLoadingPostPendidikan,
    showLoadingPostJasAlm,
    showLoadingPostPekerjaan,
    showLoadingPostAkunUM,
    showLoadingPostDefer
} = calonMhsSlice.actions

export default calonMhsSlice.reducer
